import $ from 'jquery';
import MeganavMenu from '../snippets/MeganavMenu';

export default class MobileCollectionsDynamicSection {
  constructor(section) {
    this.$el = $(section.el);
    this.menu = new MeganavMenu(this.$el);
  }

  onSectionUnload() {
    this.menu.unload();
  }
}
